export default __webpack_public_path__ + "static/precog_wordmark-b1e113b3af740c9111f6f6b6f592d5ce.png";